import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'
import ArgusStatePanel from './ui/ArgusStatePanel'

function ErrorFallback() {
  return (
    <ArgusStatePanel
      variant="error"
      eyebrow="ARGUS // RECOVERY"
      title="Something went wrong"
      message="ARGUS hit an unexpected application error. Reload the current workspace to recover the session."
      action={
        <button onClick={() => window.location.reload()} className="hd-btn-primary min-h-11 px-5">
          Reload App
        </button>
      }
      fullScreen
    />
  )
}

export default function ErrorBoundary({ children }) {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, info) => {
        console.error('ErrorBoundary caught:', error, info.componentStack)
      }}
    >
      {children}
    </ReactErrorBoundary>
  )
}
